import { inject, Injectable } from '@angular/core';
import { FormControl, FormGroup, NonNullableFormBuilder, Validators } from '@angular/forms';

import { Keyword } from 'src/app/models/keyword';

import { KeywordAddFormFactory } from './keywordAddFormFactory';

@Injectable({
  providedIn: 'root'
})
export class KeywordFormFactory {
  formBuilder = inject(NonNullableFormBuilder);
  keywordAddFormFactory = inject(KeywordAddFormFactory);

  build(keyword?: Keyword): FormGroup {
    const formArray = this.formBuilder.array<FormGroup>([]);
    if (keyword?.keywordValues && keyword.keywordValues.length > 0) {
      keyword.keywordValues.forEach((value) => {
        formArray.push(this.keywordAddFormFactory.build(value));
      });
    }
    return this.formBuilder.group({
      id: new FormControl(keyword?.id ?? ''),
      keywordName: new FormControl(keyword?.keywordName ?? '', [Validators.required]),
      keywordValues: formArray,
      preventDelete: new FormControl(keyword?.preventDelete ?? false),
      description: new FormControl(keyword?.description ?? '')
    });
  }
}
